export const CARD_PROPS = {
    class: 'q-pa-md q-mb-md bordered'
};

export const CARD_SM_PROPS = {
    class: 'bordered '
};
